import React, { useMemo } from "react";
import { Box, makeStyles } from "@material-ui/core";
import { filterPropsFactory, getSearchComponentMap } from "./utils/filters-record";
import { UseSearchFilters } from "./use-search-filters";
import { SearchProfileType } from "@bonliva-crm/shared";

export type Props<T extends object> = {
  filterManager: UseSearchFilters<T>;
  searchProfileType: SearchProfileType;
};

export function FavouriteFilter<T extends object>({
  filterManager,
  searchProfileType
}: Props<T>) {
  const classes = useStyles();
  const SearchComponentMap = useMemo(() => getSearchComponentMap(), []);

  const filtersProps = filterPropsFactory({
    filters: filterManager.favoriteFilters,
    favoriteFilters: filterManager.favoriteFilters,
    setFavoriteFilters: filterManager.setFavoriteFilters,
    setSearchProfileModalProps: filterManager.setSearchProfileModalProps,
    overrides: filterManager.overrides,
    searchProfiles: filterManager.searchProfiles,
    setSearchProfiles: filterManager.setSearchProfiles,
    setSearchProfileFull: filterManager.setSearchProfileFull,
    withFavourite: false,
    searchProfileType
  });

  return (
    <Box
      className={classes.flexRow}
      style={{ alignItems: "start", justifyContent: "space-between" }}
    >
      <Box
        className={classes.flexRow}
        style={{ flexWrap: "wrap", alignItems: "flex-start" }}
      >
        {filterManager?.favoriteFilters?.map((key) => {
          const s = SearchComponentMap[key];

          if (!s) {
            return null;
          }

          return <s.component key={key} {...(filtersProps[key] as any)} {...s.params} />;
        })}
      </Box>
    </Box>
  );
}

const useStyles = makeStyles((theme) => ({
  flexRow: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(2)
  }
}));
